// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-list__container[data-v-7cfc548a]{display:flex;flex-wrap:wrap;align-content:flex-start;justify-content:space-between;align-items:flex-start}.group-page-header[data-v-7cfc548a]{font-size:28px;font-weight:bold}\n", ""]);
// Exports
module.exports = exports;
